export const GET_CONDO_DETAILS = 'getCondoDetail';
export const GET_LIST_PRIZES = 'getListPrizes';
export const GET_PRIZES = 'getPrizes';